import api from '#config/api';
import { getQueryString } from '#utils/parseUrl';

const unwrap = (res, fallbackMessage) => {
  if (res.ok) {
    return res.data;
  }
  const raw = res.data;
  const msg =
    (raw && typeof raw.message === 'string' && raw.message) ||
    (raw && typeof raw.error === 'string' && raw.error) ||
    res.problem;
  throw new Error(typeof msg === 'string' && msg ? msg : fallbackMessage);
};

export const getTasks = async ({ legalCaseId, ...query }) => {
  const res = await api.get(`/tasks/${legalCaseId}${getQueryString(query)}`);
  return unwrap(res, 'Error al cargar las tareas');
};
export const createTask = async data => {
  const res = await api.post('/tasks', data);
  return unwrap(res, 'Error al crear la tarea');
};
export const updateTask = async ({ id, ...data }) => {
  const res = await api.put(`/tasks/${id}`, data);
  return unwrap(res, 'Error al actualizar la tarea');
};
export const deleteTask = async id => {
  const res = await api.delete(`/tasks/${id}`);
  return unwrap(res, 'Error al eliminar la tarea');
};
export const getWorkspaceTasks = async query => {
  const res = await api.get(`/tasks${getQueryString(query)}`);
  return unwrap(res, 'Error al cargar las tareas del workspace');
};
